export default "__VITE_ASSET__BV6moQr4__"